// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__0T5na","banner":"Home_banner__SHbbl","main":"Home_main__QYgAS","bookList":"Home_bookList__6DZN2"};